import { getABTest, getIsAbTest } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { createContentModelSelector, getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsUngatedForAIExperimentation, getIsUngatedForNonAIExperimentation } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { createSelector } from 'reselect';

// @ts-expect-error type mismatch
const getSubject = createContentModelSelector('subject');
export const getIsSimpleAbTest = createSelector([getIsUngatedForNonAIExperimentation, getIsUngatedForAIExperimentation, getABTest, getIsAbTest], (isUngatedForNonAIExperimentation, isUngatedForAIExperimentation, abTest, isAbTest) => isAbTest && (isUngatedForNonAIExperimentation || isUngatedForAIExperimentation) && !!abTest && (abTest.abTestType === 'SUBJECT_LINE' || abTest.abTestType === 'AI_SUBJECT_LINE'));
export const getIsSimpleAbTestAIFlow = createSelector([getIsUngatedForAIExperimentation, getABTest, getIsAbTest], (isUngatedForAIExperimentation, abTest, isAbTest) => isAbTest && isUngatedForAIExperimentation && !!abTest && abTest.abTestType === 'AI_SUBJECT_LINE');
export const getSimpleAbTestVersionData = createSelector([getABTest, getSubject, getContentModelId, getIsSimpleAbTest], (abTest, subject, contentModelId, isSimpleAbTest) => {
  if (!isSimpleAbTest) {
    return [];
  }
  const masterData = {
    id: contentModelId,
    subject
  };
  const sortedVariants = (abTest === null || abTest === void 0 ? void 0 : abTest.variations.filter(v => v.id !== contentModelId).sort((a, b) => {
    var _a$content$created, _b$content$created;
    return ((_a$content$created = a.content.created) !== null && _a$content$created !== void 0 ? _a$content$created : 0) - ((_b$content$created = b.content.created) !== null && _b$content$created !== void 0 ? _b$content$created : 0);
  }).map(v => ({
    id: v.id,
    subject: v.content.subject
  }))) || [];
  return [masterData, ...sortedVariants].map((v, index) => ({
    id: v.id,
    subject: v.subject,
    versionName: String.fromCharCode(65 + index)
  }));
});